//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const consola = require('consola'); consola.level = process.env.CONSOLA_LEVEL;
import { mapGetters, mapMutations, mapActions } from 'vuex'
import domel from '~/components/domel'
import EditButton from '~/components/cms-edit-button'
const cloneDeep = require('lodash.clonedeep')
import '@mdi/font/css/materialdesignicons.css'

import {
	VIcon,
	VBtn,
} from 'vuetify/lib'

export default {

	components:
	{
		VIcon,
		VBtn,

		domel
	},

	props:
	{
		tag:
		{
			type: String,
			default: 'div'
		},

		active:
		{
			type: Boolean,
			default: false,
		},

		noBorder:
		{
			type: Boolean,
			defualt: false,
		},

		minWidth:
		{
			type: Number,
			default: 0,
		},

		buttonStyle:
		{
			type: String,
			default: ''
		},


		// list:
		// {
		// 	type: Array,
		// 	default: []
		// },
		// pageData:
		// {
		// 	// type: Array,
		// 	required: true
		// },

		insertType:
		{
			type: String,
			default: '',
		},

		grid:
		{
			type: String,
			default: 'admin-ui-edit-list-grid',
		},

		gridCell:
		{
			type: String,
			default: '',
		},

		blockIndex:
		{
			type: Number,
			required: true,
		},

		innerBlockIndex:
		{
			type: Number,
			default: -1,
		},

		isEntry:
		{
			type: Boolean,
			default: false,
		},

		entryLocales:
		{
			type: Array
		},

		// parentBlock:
		// {
		// 	type: Object,
		// 	default: null,
		// },

		fields:
		{
			type: Array,
			default: null,
		},

		label:
		{
			type: String,
			default: "List"
		},

		type:
		{
			type: String,
			default: 'block'
		},

		block_type:
		{
			type: String,
			default: ''
		},
	},

	// data()
	// {
	// 	return {

	// 	}
	// },

	computed:
	{
		...mapGetters(['getString', 'lang', 'langShort', 'allLanguages', 'adminPanelRef']),
	},

	mounted()
	{
		if ( !this.isEntry && !this.fields )
		{
			console.error('cms-edit error: fields param is empty')
		}
	},

	methods:
	{
		handleClick(event)
		{
			if (!this.adminPanelRef)
			{
				consola.debug('error: adminPanelRef == null')
				return;
			}

			if ( !this.isEntry && !this.fields )
			{
				console.error('cms-edit error: fields param is empty')
				return;
			}

			// debugger;

			if ( !this.isEntry )
			{
				const pageData = this.adminPanelRef.getPageLocaleData();
				let locales = [];
				for (let i = 0; i < this.allLanguages.length; i++)
				{
					if (this.innerBlockIndex > -1)
						locales.push(
							cloneDeep( pageData[i].block_list[this.blockIndex].extra_data[this.innerBlockIndex].extra_data )
						)
					else
						locales.push(
							cloneDeep( pageData[i].block_list[this.blockIndex].extra_data )
						)
				}

				var extra_data_table = (this.innerBlockIndex > -1) ?
						pageData[0].block_list[this.blockIndex].extra_data[this.innerBlockIndex].extra_data_table
						: pageData[0].block_list[this.blockIndex].extra_data_table;

				this.$root.$emit('open:cms-list-edit', {
					// list: this.list,
					// parentBlock: this.parentBlock,
					blockIndex: this.blockIndex,
					innerBlockIndex: this.innerBlockIndex,
					localeList: locales,
					insertType: this.insertType,
					grid: this.grid,
					gridCell: this.gridCell,
					extra_data_table: extra_data_table,
					fields: this.fields,
					label: this.label,
					type: this.type,
					block_type: this.block_type,
				});
			}
			else
			{
				if ( !this.entryLocales )
				{
					consola.debug('entryLocales is empty')
					return;
				}

				this.$root.$emit('open:cms-entry-edit', {
					// list: this.list,
					// parentBlock: this.parentBlock,
					blockIndex: this.blockIndex,
					innerBlockIndex: this.innerBlockIndex,
					localeList: ( this.entryLocales ),
					insertType: this.insertType,
					// grid: this.grid,
					// gridCell: this.gridCell,
					// extra_data_table: extra_data_table,
					// fields: this.fields,
					label: this.label,
					type: this.type,
					block_type: this.block_type,
				});
			}
		}
	}



}
